import { toggleIn } from "./hikvisionControl";
import { OptionCard, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";

// Picks the Hikvision alarm inputs (login response ioInputs) the "Alarm Input" rule applies to.
// Only shown when an alarm input rule was chosen on the Rules step.
const HikvisionStepInputs = ({ ioInputs, selectedInputIds, setSelectedInputIds, onNext, onBack, isLastStep, lastStepLabel = "Link Hikvision" }) => (
    <>
        <StepHeader title="Which alarm inputs would you like to control?" subtitle="The alarm input rule will apply to these inputs" />
        <StepBody>
            {ioInputs.length === 0 && (
                <p style={{ color: "var(--text-label)", fontSize: "14px", textAlign: "center", marginTop: "2rem" }}>
                    No alarm inputs were found on this Hikvision.
                </p>
            )}
            {ioInputs.map(input => (
                <OptionCard
                    key={input.id}
                    title={input.name || input.id}
                    subtitle={input.ioType}
                    selected={selectedInputIds.includes(input.id)}
                    onClick={() => setSelectedInputIds(prev => toggleIn(prev, input.id))}
                />
            ))}
        </StepBody>
        <StepNav
            onBack={onBack}
            onNext={onNext}
            nextDisabled={selectedInputIds.length === 0}
            nextLabel={isLastStep ? lastStepLabel : "Next"}
            nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
        />
    </>
);

export default HikvisionStepInputs;
